import React, {useState} from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fab,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
    withStyles
} from "@material-ui/core";
import {Add, Edit, Delete} from "@material-ui/icons";
import {appStyles} from "../../styles";
import FlightOptionsContext from "../Session/flightOptionsContext";
import {withFirebase} from "../Firebase";
import ConfirmDialog from "../Forms/ConfirmDialog";

const TailNumberForm = (props) => {
    const {open, handleClose, data, firebase, isAdding} = props;
    const [name, setName] = useState(data.name);

    const handleSave = () => {
        const updatedData = {
            name,
        };
        if (isAdding) {
            firebase.tailNumbers().add(updatedData).then(() => handleClose());
        } else {
            firebase.tailNumber(data.id).set(updatedData).then(() => handleClose());
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{isAdding ? 'Add Tail Number' : 'Edit Tail Number'}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField id="tail-number-name" label="Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    );
}

const TailNumbersSettings = (props) => {
    const {classes, firebase} = props;
    const flightOptions = React.useContext(FlightOptionsContext);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const handleEdit = (id) => {
        setSelected({id, ...flightOptions.tailNumbers[id]});
        setOpen(true);
    };

    const handleAdd = () => {
        setSelected({
            name: '',
        });
        setIsAdding(true);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelected(null);
        setIsAdding(false);
    };

    const handleDelete = (id) => {
        setItemToDelete(id);
        setConfirmOpen(true);
    };

    const handleConfirmDelete = () => {
        if (itemToDelete) {
            firebase.tailNumber(itemToDelete).delete().then(() => {
                setItemToDelete(null);
                setConfirmOpen(false);
            });
        }
    };

    if (!flightOptions.tailNumbers) {
        return null;
    }

    return (
        <Paper className={classes.paper}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Tail Numbers</Typography>
                <Fab className={`${classes.fab} ${classes.fabAdd}`}
                     color="secondary"
                     aria-label="add"
                     size={"small"}
                     onClick={handleAdd}
                >
                    <Add />
                </Fab>
            </Box>
            <Table className={classes.settingsTable}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.settingsTableCell}>Name</TableCell>
                        <TableCell className={classes.settingsTableCell}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.keys(flightOptions.tailNumbers).sort((a, b) => {
                        const nameA = flightOptions.tailNumbers[a].name.toUpperCase();
                        const nameB = flightOptions.tailNumbers[b].name.toUpperCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    }).map((keyName) => (
                        <TableRow key={keyName} className={classes.hoverRow}>
                            <TableCell className={classes.settingsTableCell}>{flightOptions.tailNumbers[keyName].name}</TableCell>
                            <TableCell className={classes.settingsTableCell}>
                                <Box display="flex" justifyContent="flex-end">
                                    <IconButton aria-label="edit" onClick={() => handleEdit(keyName)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton aria-label="delete" onClick={() => handleDelete(keyName)}>
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {selected && <TailNumberForm open={open} handleClose={handleClose} data={selected} isAdding={isAdding} firebase={firebase} {...props}/>}
            <ConfirmDialog open={confirmOpen}
                           title="Delete Tail Number"
                           text="Are you sure you want to delete this tail number?"
                           onCancel={() => setConfirmOpen(false)}
                           onConfirm={handleConfirmDelete}/>
        </Paper>
    );
};

export default withFirebase(withStyles(appStyles)(TailNumbersSettings));
